<template>
    <div>
        <div :class="classe" class="aviso pt-2 pb-2 text-center"><small>AMBIENTE DE HOMOLOGAÇÃO</small></div>
        <header class="text-uppercase">
            <div class="container">
                <nav class="navbar navbar-expand-lg">
                    <router-link :to="{name: 'index'}" class="navbar-brand mr-4" :style="resolution < 400 ? 'width: 130px;' : ''" style="width: auto;"><img src="@/assets/img/logo.svg" class="img-fluid mt-2" alt="PcdoB" style="width: auto; height: 70%"></router-link>
                    <div class="navbar-text slogan">
                        <span>PCdoB</span> Digital
                    </div>
                    <button class="navbar-toggler" type="button">
                        <span class="ion-navicon-round"></span>
                    </button>



                    <div class="collapse navbar-collapse" id="menu">
                        <ul class="navbar-nav mr-0 ml-auto text-right">
                        <li class="nav-item" v-for="m in menu" v-if="m.viewHeader">
                          <router-link v-if="m.route" :to="{name: m.route, params: m.params}" class="nav-link">{{ m.label }}</router-link>
                          <a v-if="m.url" :href="m.url" class="nav-link">{{ m.label }}</a>
                          <a v-if="m.funcao" href="#" @click.prevent="m.funcao" class="nav-link nav-function">{{ m.label }}</a>
                        </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    </div>
</template>

<script>
  export default {
    computed: {
        menu() {
            return this.$store.getters.menu
        },
        classe() {
            return process.env.NODE_ENV
        },
        resolution () {
            return $(document).width()
        },
    },
      created() {
          $(() => {
              $('#menu').find('.nav-item').find('a').click(() => {
                  $('#menu').removeClass('show')
              });
              $('.navbar-toggler').click(() => {
                  if($('#menu').hasClass('show')){
                      $('#menu').removeClass('show')
                  }
                  else{
                      $('#menu').addClass('show')
                  }
              })
          })
      }
  }
</script>

<style scoped>
    .aviso{
        display: none;
    }
    .staging, .development{
        display: block !important;
        background: #f39c12;
    }
</style>



// WEBPACK FOOTER //
// src/components/includes/Header.vue